module.exports = __webpack_public_path__ + "media/app/components/MainNav/Kamereo.ac1bf439.svg";